import React, { useEffect, useState } from "react";
import MileageOnly from "./MileageOnly";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { getPrePopulatedAnswers } from "../helpers";
import { createMileageSchema } from "./schema";
import {
  getAppraisalData,
  getMileageIsReadyToRender,
  getSourceSystemIsSell,
  getSourceSystemContent,
  getSourceSystemIsBranchAppraisal,
  selectAppraisal
} from "../../store/selectors";
import { PageLayout, MileageSkeletonLoader } from "../../components";
import { MileageHelmet } from "../../components/SellHelmets";
import { appraisalSlice, updateVehicle } from "../../store/slices/Appraisal";
import { useRetryRequest } from "../../hooks/useRetryRequest";
import { errorMessages } from "../../data/filterTypes";

export default function MileageOnlyContainer() {
  const {
    appraisalSessionId,
    questions,
    sourceSystem,
    vehicle,
    questionsAndAnswers,
    userEnteredMileage
  } = useSelector(getAppraisalData);

  const [validationError, setValidationError] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [mileage, setmileage] = useState(userEnteredMileage);
  const [hasMileageChanged, setHasMileageChanged] = useState(false);
  const [loading, setLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const dispatch = useDispatch();

  const { isManual, loading: storeLoading } = useSelector(selectAppraisal);
  const isSell = useSelector(getSourceSystemIsSell);
  const readyToRender = useSelector(getMileageIsReadyToRender);
  const { quickValuation } = useSelector(getSourceSystemContent);
  const isBranchAppraisal = useSelector(getSourceSystemIsBranchAppraisal);

  const { questionsRequest, appraisalRequest, vehicleAndQuestionsRequest } =
    useRetryRequest();

  const { search } = location;
  const urlParams = new URLSearchParams(search);
  const regParam = urlParams.get("registration");
  const idParam = urlParams.get("appraisalSessionId");
  const handleLanding = () => {
    if (idParam) {
      dispatch(appraisalSlice.actions.setAppraisalSessionId(idParam));
    }
    if (appraisalSessionId && !isBranchAppraisal && regParam && !storeLoading) {
      vehicleAndQuestionsRequest(regParam);
    }
  };
  useEffect(handleLanding, [
    dispatch,
    appraisalSessionId,
    location,
    sourceSystem,
    isBranchAppraisal
  ]);

  const handleFetchAppraisal = () => {
    if (isBranchAppraisal) {
      appraisalRequest().then(() => {
        questionsRequest();
      });
    }
  };
  useEffect(handleFetchAppraisal, [
    isBranchAppraisal,
    isManual,
    appraisalSessionId
  ]);

  useEffect(() => {
    if (quickValuation && readyToRender) {
      const defaultAnswers = getPrePopulatedAnswers(questions);
      dispatch(appraisalSlice.actions.setQuestionsAndAnswers(defaultAnswers));
    }
  }, [dispatch, questions, quickValuation, readyToRender]);

  const handleWrongCar = () => {
    dispatch(appraisalSlice.actions.removeVehicle());
    if (isSell) {
      if (isManual) {
        navigate(`/manual-enquiry?registration=${vehicle.registration}`, {
          replace: true
        });
      } else {
        window.location.assign(process.env.REACT_APP_SELL_HOME);
      }
    } else {
      navigate("/registration");
    }
  };

  const handleMileageInput = (value) => {
    setmileage(value);
  };

  const submitMileage = (value) =>
    dispatch(updateVehicle({ mileage: value, appraisalSessionId })).then(
      (response) => {
        if (response.error?.message === errorMessages.NETWORKERROR) {
          retryRequest(() => submitMileage(value));
        } else if (
          response.error &&
          response.error?.message !== errorMessages.NETWORKERROR
        ) {
          console.log(response.error);
          setHasError(true);
        } else {
          setHasMileageChanged(true);
          dispatch(appraisalSlice.actions.setMileage(mileage));
          dispatch(appraisalSlice.actions.setIsOnline(true));
        }
      }
    );

  const retryRequest = (request) => {
    dispatch(appraisalSlice.actions.setIsOnline(false));
    setTimeout(() => {
      request();
    }, 3000);
  };

  const handleSubmit = (motLastMileage) => {
    createMileageSchema(motLastMileage)
      .validate({ mileage })
      .then(async () => {
        setLoading(true);
        await submitMileage(mileage);
        navigate("/image-upload-milage-only");
      })
      .catch(({ message }) => {
        setValidationError(message);
      });
  };

  return (
    <>
      {!readyToRender ? (
        <>
          <MileageHelmet />
          <PageLayout>
            <div>
              <PageLayout.Header title="Enter your mileage" step={2} />
            </div>
            <PageLayout.Content>
              <MileageSkeletonLoader />
            </PageLayout.Content>
          </PageLayout>
        </>
      ) : (
        <MileageOnly
          onSubmit={handleSubmit}
          handleWrongCar={handleWrongCar}
          handleMileageInput={handleMileageInput}
          validationError={validationError}
          isBranchAppraisal={isBranchAppraisal}
          loading={loading}
          mileage={mileage}
          hasMileageChanged={hasMileageChanged}
          hasError={hasError}
        />
      )}
    </>
  );
}
